<template>
  <div class="redoc-container">
    <RedocStandalone
      v-if="swaggerJson && swaggerLoaded"
      :specUrl="swaggerJson"
      :options="redocOptions"
      :onLoaded="addDeveloperKeyInField"
    />
    <p v-if="loaded && (!swaggerJson && swaggerLoaded)" class="no-swagger-message">No swagger file uploaded</p>
  </div>
</template>

<script>
import { RedocStandalone } from 'oah-redoc-plugin'
import apiInfoMixin from '@/mixins/api-info'
import { getDeveloperCredentialKey } from '@/api/profile'

export default {
  name: 'ApiInfoEndpoints',
  components: { RedocStandalone },
  mixins: [apiInfoMixin],
  props: {
    profileId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      swaggerJson: {},
      swaggerLoaded: false,
      loaded: false,
      id: '',
      redocOptions: {
        hideDownloadButton: true,
        hideHostname: false,
        portalType: this.profileId !== '' ? 'branded' : 'temp',
        theme: {
          colors: {
            primary: { main: '#57abf0' },
            http: {
              get: '#fd7e14',
              post: '#248fb2',
              put: '#9b708b',
              options: '#d3ca12',
              patch: '#e09d43',
              delete: '#e27a7a',
              basic: '#999',
              link: '#31bbb6',
              head: '#c167e4'
            }
          },
          rightPanel: {
            width: '33%'
          },
          typography: {
            code: {
              wrap: true
            }
          }
        }
      },
      developerKey: ''
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  async created() {
    await this.initialise()
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      await this.getAPISwagger()
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    async getAPISwagger() {
      // TODO: Handle in store
      if (this.apiInfo && this.apiInfo[0]?.swagger_file) {
        if (this.apiInfo[0].swagger_file.charAt(0) === '"') {
          this.apiInfo[0].swagger_file = this.apiInfo[0].swagger_file.substring(1, this.apiInfo[0].swagger_file.length - 1)
        }
        try {
          this.swaggerJson = JSON.parse(this.apiInfo[0].swagger_file.replace(/\\"/g, '\"').replace(/\\\\/g, '\\'))
        } catch (err) {
          this.swaggerJson = JSON.parse(this.apiInfo[0].swagger_file)
        }
      } else {
        this.swaggerJson = null
      }
      this.swaggerLoaded = true
    },
    async addDeveloperKeyInField() {
      if (this.userProfile?.id) {
        const { data: developerKeyRes } = await getDeveloperCredentialKey(this.userProfile.id).catch(err => console.log(err))
        this.developerKey = developerKeyRes[0]?.secret_key
        var selectField = document.getElementsByTagName('select')
        selectField.length > 0 ? Array.prototype.forEach.call(selectField, field => {
          if (field.previousElementSibling?.innerText.toLowerCase() === 'X-OpenAPIHub-Key'.toLowerCase()) {
            if (developerKeyRes.length > 0) {
              var keyNameOption = document.createElement('option')
              keyNameOption.label = developerKeyRes[0].project_name
              keyNameOption.disabled = true
              keyNameOption.style.fontSize = '12px'
              keyNameOption.style.color = '#999999'
              field.append(keyNameOption)
              var option = document.createElement('option')
              option.value = this.developerKey
              option.label = this.developerKey.substring(0, 4) + '●●●●●●●●●●●●●●●●●'
              option.style.color = '#505050'
              field.append(option)
            } else {
              var noKeyOption = document.createElement('option')
              noKeyOption.label = 'No available API Keys, please generate one at "Credentials" on the Developer Admin Portal'
              noKeyOption.value = ''
              noKeyOption.disabled = true
              noKeyOption.style.fontSize = '14px'
              noKeyOption.style.color = '#505050'
              noKeyOption.style.maxWidth = '100%'
              field.append(noKeyOption)
            }
          }
        }) : null
      }
    }
  }
}
</script>

<style>
.redoc-wrap {
  padding-top: 3px;
}
.no-swagger-message {
  margin: 48px 24px;
  text-align: center;
}
.iCJQe0 {
  padding: 12.5px 0;
}
.lerNRm {
  padding-top: 1em;
}
.kQHriH {
  padding: 0;
}
.pBKeH {
  padding: 0;
  word-break: break-word;
}
.kwETCH {
  padding: 0;
}
.hwqXNm {
  padding: 40px 0 0 0;
}
.sc-fzqBkg.sc-fzqPZZ.iSEOGS {
  color: white;
  display: contents;
}
.iSEOGS .token.string {
  color: #009FFF !important;
}
.iSEOGS .token.number, .iSEOGS .token.keyword, .iSEOGS .token.boolean {
  color: red !important;
}
.redoc-container {
  min-height: 30vh;
}
@media screen and (max-width: 768px) {
  .gXcumP table tr {
    display: table-row !important;
    margin-bottom: 0px !important;
  }
  .jEBobi tr {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
  .knqxzs {
    min-width: 17.5%;
  }
  .fNYEXC {
    width: 100% !important;
  }
}
</style>

